"use strict";
(function (ShaderType) {
    ShaderType[ShaderType["PLAIN"] = 0] = "PLAIN";
    ShaderType[ShaderType["SPRITE"] = 1] = "SPRITE";
    ShaderType[ShaderType["TEXTURE_SOLID"] = 2] = "TEXTURE_SOLID";
    ShaderType[ShaderType["TEXTURE_POROUS"] = 3] = "TEXTURE_POROUS";
})(exports.ShaderType || (exports.ShaderType = {}));
var ShaderType = exports.ShaderType;
//# sourceMappingURL=types.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/types.js
 ** module id = 119
 ** module chunks = 0
 **/